<template>
    <modal-dialog
        ref="modalDialog"
        confirmBtnTxt="Proceed"
        :isLoading="isLoading"
        @confirm-dialog="save()"
    >
        <template v-slot:title>
            {{ isDelete ? "Delete" : "Disable" }}
            Production Credit
        </template>
        <template v-slot:body>
            <div v-if="!isDelete">
                Once this production credit is disabled, it will no longer be
                available for use in providers profiles. Any existing uses of
                this production credit will not be affected, but this production
                credit will be removed from client profiles. Do you want to
                proceed disable :
                <b>{{ productionCredit ? productionCredit.name : "" }}</b> ?
            </div>
            <div v-else>
                Please confirm that you wish to
                {{ isDelete ? "delete" : "disable" }}
                this production credit :
                <b>{{ productionCredit ? productionCredit.name : "" }}</b> ?
            </div>
        </template>
    </modal-dialog>
</template>
<script>
import productionCreditService from "@/services/setting/production-credits";
import ModalDialog from "@/components/commons/modal-dialog";

export default {
    components: {
        ModalDialog
    },
    data() {
        return {
            isLoading: false,
            productionCredit: null,
            isDelete: true
        };
    },
    methods: {
        async open(data, isDelete = true) {
            this.$refs.modalDialog.open();
            if (data) {
                this.productionCredit = data;
            }
            this.isDelete = isDelete;
        },
        close() {
            this.$refs.modalDialog.close();
        },
        async save() {
            this.isLoading = true;
            productionCreditService
                .deleteProductionCredit(
                    this.productionCredit.id +
                        (this.productionCredit.total_used === "No"
                            ? "/0"
                            : "/1")
                )
                .then(response => {
                    if (response && response.code == 200) {
                        this._message(response.resource);
                        this.$emit("reload");
                    } else {
                        this._message(response.message, "danger");
                    }
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to delete production credit",
                        "danger"
                    );
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                    this.close();
                });
        }
    }
};
</script>
